module.exports = __webpack_public_path__ + "static/media/javascriptgoodparts.7b21b255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/javascriptgoodparts.jpg
// module id = 302
// module chunks = 0